/*******************************************************
 * ROUTES SERVICE
 *******************************************************/

"use strict";


/**
 * Module SERVICES
 */
angular.module("services")

	.factory("NetworkService", ["$http", "ENV", function ($http, ENV) {

		return {
			findNetworkById: findNetworkById
		};


		/**
         * Retourne les informations d'un réseau
         * @param pattern
         * @returns {*}
         */
		function findNetworkById(pattern) {
			return $http.get(ENV.API_URL + "/exploitation/reseau/" + pattern)
				.then((response) => {
					return response.data;
				});
		}

	}]);


